import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacy from "../pages/privacy/page";
import PrivacyEn from "../pages/privacy-en/page";
import Terms from "../pages/terms/page";
import About from "../pages/about/page";
import B2B from "../pages/b2b/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/b2b",
    element: <B2B />,
  },
  {
    path: "/sobre",
    element: <About />,
  },
  {
    path: "/privacidade",
    element: <Privacy />,
  },
  {
    path: "/privacy",
    element: <PrivacyEn />,
  },
  {
    path: "/termos",
    element: <Terms />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
